import React, { useState } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import notify from "../../ReusableComponents/ToastifyAlerts";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { Row, Col } from "react-bootstrap";
const AddEditHierarchy = (props) => {
const [AddHierarchy, SetAddHierarchy] = useState(props.data.Edit && props.data?.hierarchy);
      const postHierarchy = async () => {
        try{
            const res = await axiosInstance.post(`/NCLAdmin/InsertInstituteHierarchy?InstituteId=${props.data.instituteId}&Hierarchy=${AddHierarchy}&CreatedBy=1`);
            console.log(res.data);
            props.Clear()
            props.GetList();
            notify("Hierarchy added successfully", "success");
        }
        catch (err){
        console.log(err)
        }
      }
      const EditHierarchy = async () => {
        try{
            const res = await axiosInstance.post(`/NCLAdmin/UpdateInstituteHierarchy?InstituteId=${props.data.instituteId}&InstituteHierarchyId=${props.data?.hierarchyId}&Hierarchy=${AddHierarchy}&CreatedBy=1`);
            console.log(res.data);
            props.Clear()
            props.GetList();
            notify("Hierarchy updated successfully", "success");
        }
        catch (err){
        console.log(err)
        }
      }
    return (
        <>
           <div className="Card AddStudent-maindiv p-3"style={{ width: "550px", margin: "0 auto" }}>
                 <div className="dflex alignitems JSBetween">
                      <div className="AddStudent-Title Helvetica">Institute : {props.data?.instituteName}</div>
                      <IoMdCloseCircleOutline onClick={() => props.Clear(false)} />
                    </div>
                <div className="container-fluid">
                    <Row>
                        {!props.data.Edit && (
                        <Col md={12}>
                            <div className="DropdownHeader">Parent Value<span>*</span></div>
                            <input
                            type="text"
                            value={props.data?.hierarchy}
                            className="NCLDropdown w-100"
                            disabled
                            />
                        </Col>
                        )}
                        {/* Hierarchy Field */}
                        <Col md={12}>
                        <div className="DropdownHeader mt-3">Hierarchy<span>*</span></div>
                        <input
                            type="text"
                            value={AddHierarchy}
                            className="NCLDropdown w-100"
                            onChange={(e) => SetAddHierarchy(e.target.value)}
                        />
                        </Col>
                    </Row>
                 </div>
                 <div className="AddStudent-Buttons dflex mt-3">
                    <button
                        className="Buttons"
                        onClick={() => (props.data.Edit ? EditHierarchy() : postHierarchy())}
                    >
                        {props.data.Edit ? "Update" : "Save"}
                    </button>
                     <button className="Buttons CancleButton" onClick={() => props.Clear()}>
                        Cancel
                    </button>
                    </div>
            </div>
        </>
    );
};
export default AddEditHierarchy;